import { DadosPropostaResponse } from "#/types";
import { request } from "#/utils/request";
import { useQuery } from "@tanstack/react-query";

export const ENDPOINT_DADOS_PROPOSTA = "/propostas";

/**
 * @function getProposta - busca propostas do usuário
 */

async function getProposta() {
  const { data } = await request.get<DadosPropostaResponse>(
    ENDPOINT_DADOS_PROPOSTA
  );

  return data;
}

export function useDadosProposta() {
  return useQuery({
    queryKey: ["dadosProposta"],
    queryFn: getProposta,
  });
}

export default useDadosProposta;
